import {
  ArrowLeftStroke,
  CheckStroke,
  FloppyDisk1Stroke,
  Pencil1Stroke,
  RefreshCircle1ClockwiseStroke,
  Share1Stroke,
  SignPostLeftStroke,
  Trash3Stroke,
  XmarkStroke
} from '@lineiconshq/free-icons';
import React from 'react';
import { ActionButtonV2 } from '@/components/custom/erp';
import { FormMode } from '@/types/form';

/**
 * Get the title for the form dialog based on form mode and active tab
 */
export const getFormTitle = (formMode: FormMode, activeTab: string) => {
  if (formMode !== 'view') {
    return formMode === 'add' ? 'Mới' : 'Sửa';
  }

  switch (activeTab) {
    case 'info':
      return 'Đơn hàng';
    case 'history':
      return 'Lịch sử';
    default:
      return 'Đơn hàng';
  }
};

/**
 * Get the action buttons for the form dialog based on form mode and active tab
 */
export const getFormActionButtons = (
  formMode: FormMode,
  activeTab: string,
  handlers: {
    onAdd?: () => void;
    onEdit?: () => void;
    onDelete?: () => void;
    onCopy?: () => void;
    handleClose: () => void;
    onSendForProcessing?: () => void;
    onApprove?: () => void;
    onReject?: () => void;
    onUndo?: () => void;
  },
  status?: string
) => {
  const { onAdd, onEdit, onDelete, onCopy, handleClose, onSendForProcessing, onApprove, onReject, onUndo } = handlers;

  if (formMode !== 'view') {
    return null;
  }

  switch (activeTab) {
    case 'info':
      return (
        <>
          {/* Show "Gửi xử lý" button when status is '0' (Lập chứng từ) */}
          {status === '0' && <ActionButtonV2 icon={Share1Stroke} title='Gửi xử lý' onClick={onSendForProcessing} />}

          {/* Show "Duyệt" and "Từ chối" buttons when status is '1' (Chờ duyệt) */}
          {status === '1' && (
            <>
              <ActionButtonV2 icon={CheckStroke} title='Duyệt' onClick={onApprove} />
              <ActionButtonV2 icon={XmarkStroke} title='Từ chối' onClick={onReject} />
            </>
          )}

          {/* Show "Bỏ lệnh" button when status is '5' (Đã duyệt) or '9' (Đóng) */}
          {(status === '5' || status === '9') && (
            <ActionButtonV2 icon={ArrowLeftStroke} title='Bỏ lệnh' onClick={onUndo} />
          )}

          <ActionButtonV2 icon={Pencil1Stroke} title='Sửa' onClick={onEdit} />
          <ActionButtonV2 icon={Trash3Stroke} title='Xóa' onClick={onDelete} />
          <ActionButtonV2 icon={ArrowLeftStroke} title='Đóng' onClick={handleClose} />
        </>
      );
    case 'history':
      return (
        <>
          <ActionButtonV2
            icon={RefreshCircle1ClockwiseStroke}
            title='Refresh'
            variant='secondary'
            onClick={() => console.log('refresh')}
          />
          <ActionButtonV2
            icon={SignPostLeftStroke}
            title='Cố định cột'
            variant='secondary'
            onClick={() => console.log('pin')}
          />
          <ActionButtonV2 icon={ArrowLeftStroke} title='Đóng' variant='secondary' onClick={handleClose} />
        </>
      );
    default:
      return (
        <>
          <ActionButtonV2 icon={FloppyDisk1Stroke} title='Lưu' type='submit' />
          <ActionButtonV2 icon={ArrowLeftStroke} title='Đóng' onClick={handleClose} />
        </>
      );
  }
};
